import React from 'react'
import { Switch, useRouteMatch } from 'react-router-dom'

import { AIPlanBlueprintCreatePage } from 'features/planner/AIPlanBlueprintCreatePage'
import { AIPlanBlueprintWelcomePage } from 'features/planner/AIPlanBlueprintWelcomePage'
import { AIPlanBlueprintsPage } from 'features/planner/AIPlanBlueprintsPage'
import { AIPlanCreatePage } from 'features/planner/AIPlanCreatePage'
import { AIPlanWelcomePage } from 'features/planner/AIPlanWelcomePage'
import { AIPlansPage } from 'features/planner/AIPlansPage'
import { MasterCampaignPlanWelcomePage } from 'features/planner/MasterCampaignPlanWelcomePage'
import { MasterCampaignPlansPage } from 'features/planner/MasterCampaignPlansPage'
import { MasterCampaignPlansCreatePage } from 'features/planner/old-pages/MasterCampaignPlansCreatePage'
import AIPlanBlueprintPage from 'features/planner/pages/AIPlanBlueprintPage/AIPlanBlueprintPage'
import AIPlanPageDynamic from 'features/planner/pages/AIPlanPage/AIPlanPageDynamic'
import MasterCampaignPlanPageDynamic from 'features/planner/pages/MasterCampaignPlanPage/MasterCampaignPlanPageDynamic'

import PrivateRoute from '../../components/PrivateRoute'

export const AiRoutes = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <PrivateRoute exact={true} path={`${path}/blueprints`}>
        <AIPlanBlueprintsPage />
      </PrivateRoute>
      <PrivateRoute exact={true} path={`${path}/blueprints/welcome`}>
        <AIPlanBlueprintWelcomePage />
      </PrivateRoute>
      <PrivateRoute exact={true} path={`${path}/blueprints/create`}>
        <AIPlanBlueprintCreatePage />
      </PrivateRoute>
      <PrivateRoute exact={true} path={`${path}/blueprints/:blueprintId`}>
        <AIPlanBlueprintPage />
      </PrivateRoute>
      <PrivateRoute exact={true} path={`${path}/plans`}>
        <AIPlansPage />
      </PrivateRoute>
      <PrivateRoute exact={true} path={`${path}/plans/welcome`}>
        <AIPlanWelcomePage />
      </PrivateRoute>
      <PrivateRoute exact={true} path={`${path}/plans/create`}>
        <AIPlanCreatePage />
      </PrivateRoute>
      <PrivateRoute exact={true} path={`${path}/plans/:aiPlanId`}>
        <AIPlanPageDynamic />
      </PrivateRoute>
      <PrivateRoute exact={true} path={path}>
        <MasterCampaignPlansPage />
      </PrivateRoute>
      <PrivateRoute exact={true} path={`${path}/welcome`}>
        <MasterCampaignPlanWelcomePage />
      </PrivateRoute>
      <PrivateRoute exact={true} path={`${path}/create-plan`}>
        <MasterCampaignPlansCreatePage />
      </PrivateRoute>
      <PrivateRoute exact={true} path={`${path}/:masterCampaignPlanId`}>
        <MasterCampaignPlanPageDynamic />
      </PrivateRoute>
    </Switch>
  )
}
